import { createContext } from 'react';
import type { Locale } from './format';
import type { Messages } from './messages';

export interface I18nValue {
  locale: Locale;
  setLocale: (locale: Locale) => void;
  t: Messages;
}

export const I18nContext = createContext<I18nValue | null>(null);
